<template>
  <div class="social-links-components" :class="size">
    <a href="https://twitter.com/CPEsymposium" class="social-link" target="_blank">
      <img src="../assets/twitter.svg"/>
    </a>
    <a href="https://www.instagram.com/cpes_symposium/" class="social-link" target="_blank">
      <img src="../assets/instagram.svg"/>
    </a>
    <a href="https://www.facebook.com/cpesymposium/" class="social-link" target="_blank">
      <img src="../assets/facebook.svg"/>
    </a>
    <a href="https://www.linkedin.com/company/cpes-cannabis-political-economy-symposium/" class="social-link" target="_blank">
      <img src="../assets/linkedin.svg"/>
    </a>
  </div>
</template>
<script>
export default {
  name: 'social-links-components',
  props: ['size'],
}
</script>
<style scoped lang="scss">
  .social-links-components {
    &.big {
      img {
        height: 25px;
        margin-left: 15px;
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
    }
    &.small {
      img {
        height: 18px;
        margin-left: 5px;
      }
    }
  }
</style>
